import React from 'react';
import { Link } from 'react-router-dom';
import { Youtube, Instagram, Twitter, Facebook, Linkedin, Mail, MapPin } from 'lucide-react';
import { personalInfo, socialLinks } from '../data/mockData';

const Footer = () => {
  const getSocialIcon = (platform) => {
    switch (platform.toLowerCase()) {
      case 'youtube': return <Youtube size={20} />;
      case 'instagram': return <Instagram size={20} />;
      case 'twitter': return <Twitter size={20} />;
      case 'facebook': return <Facebook size={20} />;
      case 'linkedin': return <Linkedin size={20} />;
      case 'tiktok': return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
        </svg>
      );
      default: return null;
    }
  };

  return (
    <footer className="bg-[#0a0d10] border-t border-[#1e293b]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <h3 className="font-serif text-3xl font-bold text-[#f5f5f0]">
                Jerry Fisayo-Bambi
              </h3>
            </Link>
            <p className="text-[#a0a0a0] leading-relaxed">
              Award-winning journalist, TV presenter, and communication strategist 
              dedicated to telling Africa's stories to the world.
            </p>
            <div className="flex items-center space-x-4 text-[#a0a0a0]">
              <MapPin size={18} className="text-[#d4af37]" />
              <span>{personalInfo.location}</span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-6">
            <h4 className="font-serif text-lg font-semibold text-[#f5f5f0]">
              Quick Links
            </h4>
            <nav className="flex flex-col space-y-3">
              <Link 
                to="/" 
                className="text-[#a0a0a0] hover:text-[#d4af37] transition-colors duration-300"
              >
                Home
              </Link>
              <Link 
                to="/about" 
                className="text-[#a0a0a0] hover:text-[#d4af37] transition-colors duration-300"
              >
                About
              </Link>
              <Link 
                to="/work" 
                className="text-[#a0a0a0] hover:text-[#d4af37] transition-colors duration-300"
              >
                Work
              </Link>
              <a 
                href="https://www.euronews.com/programs/inspire-africa" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#a0a0a0] hover:text-[#d4af37] transition-colors duration-300"
              >
                Inspire Africa
              </a>
            </nav>
          </div>

          {/* Contact & Social */}
          <div className="space-y-6">
            <h4 className="font-serif text-lg font-semibold text-[#f5f5f0]">
              Connect
            </h4>
            <a 
              href={`mailto:${personalInfo.email}`}
              className="flex items-center space-x-3 text-[#a0a0a0] hover:text-[#d4af37] transition-colors duration-300"
            >
              <Mail size={18} className="text-[#d4af37]" />
              <span>{personalInfo.email}</span>
            </a>
            
            {/* Social Links */}
            <div className="flex flex-wrap gap-3 pt-2">
              {socialLinks.map((social) => (
                <a
                  key={social.platform}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-[#1e293b] flex items-center justify-center text-[#a0a0a0] hover:bg-[#d4af37] hover:text-[#0f1419] transition-all duration-300"
                  aria-label={social.platform}
                >
                  {getSocialIcon(social.platform)}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[#1e293b] flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <p className="text-[#6b7280] text-sm">
            © {new Date().getFullYear()} Jerry Fisayo-Bambi. All rights reserved.
          </p>
          <p className="text-[#6b7280] text-sm">
            Journalist • Storyteller • Media Strategist
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;